var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffordable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#cb8b65;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 62.69,
    y1: 127.24,
    x2: 62.69,
    y2: 2.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed9765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.69,
    cy: 63.36,
    r: 62.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.69,
    cy: 63.36,
    r: 54.71
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 62.69,
    cy: 63.36,
    r: 42.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,93.53a3,3,0,0,1-.8-1L34.05,76.71c-.51-.89-.43-1.19.46-1.7l3.72-2.14c.71-.4,1.09-.3,1.5.4l9.36,16.25c.4.7.28,1.1-.41,1.51l-3.83,2.19a6.49,6.49,0,0,1-.65.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.16,69.19a13,13,0,0,1,4.25.84c3.44,1.13,6.9,2.22,10.34,3.34a3.29,3.29,0,0,1-.67,6.42,3.77,3.77,0,0,1-1.56-.23l-6.88-2.21a.92.92,0,0,0-1.34.83.79.79,0,0,0,.54.93c2.69.85,5.33,1.91,8.08,2.52a5.15,5.15,0,0,0,6-5.89.7.7,0,0,1,.42-.91c2.48-1.31,4.93-2.67,7.4-4a3.29,3.29,0,1,1,3.16,5.75Q75.42,81.77,65.88,87a7.79,7.79,0,0,1-6.16.59C58,87,56.35,86.37,54.61,86a7.25,7.25,0,0,0-4.55.39c-.34.14-.49.13-.69-.21q-3.24-5.67-6.52-11.32c-.19-.33-.13-.44.17-.6C45.34,73,47.64,71.7,50,70.46A10.63,10.63,0,0,1,55.16,69.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76,52.24a8.48,8.48,0,0,1,0-14.41c.46-.28.37-.43.08-.74a11.85,11.85,0,1,0-5.72,19.38,11.6,11.6,0,0,0,6.09-3.93ZM71,39.52H67.45a3.22,3.22,0,0,1,1.2,2.19H71v1.08H68.67c-.21,2.19-2,3.59-4.71,3.68,1.68,1.74,3.51,3.93,5.32,6.15H67.21c-1.68-2-3.25-3.9-5.27-6V45.24h1.18c2.33,0,3.57-1,3.73-2.45H61.94V41.71h4.84c-.3-1.25-1.44-1.87-3.31-1.87H61.94v-1.4H71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.47,38.51A6.53,6.53,0,1,0,87,45,6.53,6.53,0,0,0,80.47,38.51ZM84,44c-1.16,1.17-2.33,2.33-3.5,3.5a1.06,1.06,0,0,1-.81.4,1,1,0,0,1-.77-.37c-.66-.65-1.31-1.3-2-2a1,1,0,0,1-.1-1.45,1,1,0,0,1,1.5.1l.12.13c.41.39.8,1,1.23,1.08s.78-.68,1.17-1.07c.59-.58,1.16-1.17,1.75-1.74A1,1,0,1,1,84,44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.64,62.49l-3.37,3.34q-1.33,1.32-2.67,2.67c-.17.17-.28.32-.55,0-2-2-4-4-6-6.06,1.1,0,2.09,0,3.08,0,.55,0,.68-.16.66-.68,0-.94,0-1.89,0-2.83,0-.35.08-.41.43-.35a11.79,11.79,0,0,0,4.27,0c.43-.07.5.05.49.43,0,1,0,2,0,2.94,0,.41.13.49.5.48C71.41,62.48,72.43,62.49,73.64,62.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.84,71.67c.93-.51,1.8-1,2.69-1.46a3.19,3.19,0,0,1,3.91.76l-4.19,2.28c-.11.06-.23.17-.35,0A5.91,5.91,0,0,0,70.84,71.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordable);
export default __webpack_public_path__ + "static/media/Affordable.a93317a2c83c3b4201272db599888e63.svg";
export { ForwardRef as ReactComponent };